module.exports = __webpack_public_path__ + "static/media/FicheTechnique2024.832dc8ff.png";